/**
 * Verzögert die Ausführung von fn um delay Millisekunden.
 * Mehrfache Aufrufe innerhalb des Delays starten den Timer neu (trailing debounce).
 *
 * @param {Function} fn - Die zu verzögernde Funktion
 * @param {number} delay - Verzögerung in Millisekunden (Standard: 250ms)
 * @returns {Function} Debounced-Version von fn
 */
export function debounce(fn, delay = 250) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), delay);
  };
}
